var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-sport-winner-2",
    "data-name": "ic-sport-winner"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.2,6h5.6a.2.2,0,0,1,.2.2V18a0,0,0,0,1,0,0H9a0,0,0,0,1,0,0V6.2A.2.2,0,0,1,9.2,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3,11H8.8a.2.2,0,0,1,.2.2v6.6a.2.2,0,0,1-.2.2H3a0,0,0,0,1,0,0V11A0,0,0,0,1,3,11Z",
    transform: "translate(12 29) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.2,13H21a0,0,0,0,1,0,0v5a0,0,0,0,1,0,0H15.2a.2.2,0,0,1-.2-.2V13.2A.2.2,0,0,1,15.2,13Z",
    transform: "translate(36 31) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/diagram.d4244493bea2cba7cf1654bcc88831c8.svg";
export { ForwardRef as ReactComponent };